
import { Component, Vue } from "vue-property-decorator";
import MainView from "./components/MainView.vue";

@Component({
  components: {
    MainView
  }
})
export default class App extends Vue {}
